import React from 'react';
import Alert from '@mui/material/Alert';

const APINotice = () => {
  return (
    <>
      <Alert
        severity="info"
        sx={{
          margin: '15px 0'
        }}
      >
        Please note that these prices may not factor in the discounts available
        with your Amazon membership in the sale today as this tool uses an API
        from Amazon and sometimes Amazon does not provide special event pricing
        for certain items. Clicking the direct product link will show you the
        true price with your Amazon Prime membership discount.
      </Alert>
    </>
  );
};

export default APINotice;
